import React from 'react';
import { Icon } from './Icon.js';
export const IconAlertInfoFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,11.5c-.414,0-.75-.336-.75-.75v-6c0-.414.336-.75.75-.75s.75.336.75.75v6c0,.414-.336.75-.75.75Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "6", cy: "1.5", r: "1", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconAlertInfoFill12.js.map